/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sell_Andamp_CreateInputs */

const en_sell_andamp_create = /** @type {(inputs: Sell_Andamp_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sell & Create`)
};

const es_sell_andamp_create = /** @type {(inputs: Sell_Andamp_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vender & Crear`)
};

const fr_sell_andamp_create = /** @type {(inputs: Sell_Andamp_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vendre &amp; Créer`)
};

const de_sell_andamp_create = /** @type {(inputs: Sell_Andamp_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verkaufen & Kreieren`)
};

const ja_sell_andamp_create = /** @type {(inputs: Sell_Andamp_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`販売 ＆ 制作`)
};

const zh_sell_andamp_create = /** @type {(inputs: Sell_Andamp_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`销售 &amp; 创作`)
};

const ar_sell_andamp_create = /** @type {(inputs: Sell_Andamp_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بيع وإنشاء`)
};

const id_sell_andamp_create = /** @type {(inputs: Sell_Andamp_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menjual &amp; Membuat`)
};

const it_sell_andamp_create = /** @type {(inputs: Sell_Andamp_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vendere & Creare`)
};

const ru_sell_andamp_create = /** @type {(inputs: Sell_Andamp_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Продавать & Создавать`)
};

const pt_sell_andamp_create = /** @type {(inputs: Sell_Andamp_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vender & Criar`)
};

const ko_sell_andamp_create = /** @type {(inputs: Sell_Andamp_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`판매 & 제작`)
};

/**
* | output |
* | --- |
* | "Sell & Create" |
*
* @param {Sell_Andamp_CreateInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const sell_andamp_create = /** @type {((inputs?: Sell_Andamp_CreateInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sell_Andamp_CreateInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sell_andamp_create(inputs)
	if (locale === "es") return es_sell_andamp_create(inputs)
	if (locale === "fr") return fr_sell_andamp_create(inputs)
	if (locale === "de") return de_sell_andamp_create(inputs)
	if (locale === "ja") return ja_sell_andamp_create(inputs)
	if (locale === "zh") return zh_sell_andamp_create(inputs)
	if (locale === "ar") return ar_sell_andamp_create(inputs)
	if (locale === "id") return id_sell_andamp_create(inputs)
	if (locale === "it") return it_sell_andamp_create(inputs)
	if (locale === "ru") return ru_sell_andamp_create(inputs)
	if (locale === "pt") return pt_sell_andamp_create(inputs)
	return ko_sell_andamp_create(inputs)
});